import React, { FC } from 'react';
import dayjs from 'dayjs';
import { IHistoryItem, IHistoryItemComment } from 'entities/History/History.models';
import { EHistoryType, EHistoryTypeLabel } from 'entities/History/History.enum';

interface IComponentProps {
  item: IHistoryItem;
}

export const HistoryItem: FC<IComponentProps> = ({ item }) => {
  return (
    <div className="mb-4 pb-4 history-item">
      <div className="mb-4 d-flex align-center history-item__header">
        <span className="ff-regular color-grey">{dayjs(item.createdAt).format('MM/DD/YY - hh:mma')}</span>

        <span className="ff-regular color-grey">
          {item.actionType !== EHistoryType.received && (
            // @ts-ignore
            <span>by: {item.user?.name ? item.user.name : 'System'}</span>
          )}
        </span>
      </div>

      <div className="mb-4 ff-regular">{EHistoryTypeLabel[item.actionType]}</div>

      {(item.data as IHistoryItemComment)?.comment && (
        <div className="ff-regular color-grey">{`Comment: ${(item.data as IHistoryItemComment)?.comment}`}</div>
      )}
    </div>
  );
};
